import {
  PUSH_DEEPLINK_GROUPS,
  pushDeeplinkPath,
} from '@/lib/push-deeplinks';

export function PushDeeplinkField({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const path = pushDeeplinkPath(value);

  return (
    <div>
      <label className="mb-1 block text-sm text-nova-muted-foreground">
        Deeplink <span className="text-nova-muted-foreground">(optional)</span>
      </label>
      <select
        className="w-full rounded-lg border border-nova-border h-8 px-2.5 text-sm"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="">None — open app without navigation</option>
        {PUSH_DEEPLINK_GROUPS.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.options.map((option) => (
              <option key={option.key} value={option.key}>
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      {path ? (
        <p className="mt-1 text-xs text-nova-muted-foreground">
          Opens <code className="rounded bg-nova-muted px-1">{path}</code>
        </p>
      ) : null}
    </div>
  );
}
